module.exports = __webpack_public_path__ + "img/csepel_logo.802183a3.png";